{
  "releaseGitCommitHash": "932e107bf617d8dc7423030750a05cfb3205c64f",
  "releaseGitTag": ""
}
